@if (errorText$ | async; as content) {
	<section class="flex container">
		<app-header></app-header>
		<div class="content flex coverage">
			<div class="wrap-icon">
				<img [src]="content.asset" alt="error image" />
			</div>
			<div class="wrap-text flex">
				<div class="title">
					<p class="text">{{ content.title }}</p>
				</div>
				<div class="description">
					<p class="text">
						{{ content.description }}
					</p>
				</div>
			</div>
			<div class="wrap-button flex">
				<button
					bciWkButtonPrimary
					(click)="onButtonActionHandler(content.button.action, content.tags?.action)"
					[innerHTML]="content.button.text"
				></button>
			</div>
		</div>
		<app-footer></app-footer>
	</section>
}
